/**
 * Magnetic CTAs: within 60px of a [data-magnetic] wrapper the button leans toward the pointer.
 * Also the 3D tilt + cursor spotlight on service cards ([data-tilt], max 6 degrees).
 * Desktop fine pointers only; nothing here runs under reduced motion.
 */
import { gsap } from 'gsap';

const RADIUS = 60;

export function initMagnetic() {
  const items = [...document.querySelectorAll('[data-magnetic]')].map((el) => ({
    el,
    x: gsap.quickTo(el, 'x', { duration: 0.6, ease: 'power3.out' }),
    y: gsap.quickTo(el, 'y', { duration: 0.6, ease: 'power3.out' }),
    active: false,
  }));
  if (!items.length) return;

  let frame = null;
  let px = 0;
  let py = 0;

  const tick = () => {
    frame = null;
    items.forEach((item) => {
      const r = item.el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > window.innerHeight + 100) return;
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      const dx = px - cx;
      const dy = py - cy;
      const inside = Math.abs(dx) < r.width / 2 + RADIUS && Math.abs(dy) < r.height / 2 + RADIUS;
      if (inside) {
        item.active = true;
        item.x(dx * 0.3);
        item.y(dy * 0.35);
      } else if (item.active) {
        item.active = false;
        gsap.to(item.el, { x: 0, y: 0, duration: 0.9, ease: 'elastic.out(1, 0.4)', overwrite: true });
      }
    });
  };

  window.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse') return;
    px = e.clientX;
    py = e.clientY;
    if (!frame) frame = requestAnimationFrame(tick);
  }, { passive: true });
}

export function initTilt() {
  document.querySelectorAll('[data-tilt]').forEach((card) => {
    const rx = gsap.quickTo(card, 'rotationX', { duration: 0.6, ease: 'power3.out' });
    const ry = gsap.quickTo(card, 'rotationY', { duration: 0.6, ease: 'power3.out' });
    gsap.set(card, { transformPerspective: 900 });
    card.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = card.getBoundingClientRect();
      const nx = (e.clientX - r.left) / r.width;
      const ny = (e.clientY - r.top) / r.height;
      ry((nx - 0.5) * 12); // +-6deg
      rx((0.5 - ny) * 12);
      card.style.setProperty('--mx', `${nx * 100}%`);
      card.style.setProperty('--my', `${ny * 100}%`);
    });
    card.addEventListener('pointerleave', () => { rx(0); ry(0); });
  });
}
